import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getExtractorVersions, uploadExtractor, type UploadExtractorInput } from '../api/extractors'
import { queryKeys } from '../lib/query-client'

export function useExtractorVersions(phenotypeId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.extractors.versions(phenotypeId || ''),
    queryFn: () => getExtractorVersions(phenotypeId!),
    enabled: !!phenotypeId,
    staleTime: 1000 * 60 * 2, // 2 min — versions change after code gen completes
  })
}

export function useUploadExtractor(phenotypeId: string | undefined) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (input: UploadExtractorInput) => uploadExtractor(phenotypeId!, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.extractors.versions(phenotypeId || '') })
      queryClient.invalidateQueries({ queryKey: queryKeys.extractors.deployed(phenotypeId || '') })
    },
  })
}
